import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import BetslipBaseModule from '../../base/betslip-base.module';
import { RewardTokensBannerService } from './services/reward-tokens-banner.service';
import { RewardTokensBootstrapService } from './services/reward-tokens-bootstrap.service';
import { RewardTokensMapper } from './services/reward-tokens-mapper.service';
import { RewardTokensValidatorsModule } from './services/validators/reward-tokens-validators.module';
import { RewardTokensStateStorageService } from './state-storage';

@NgModule({
    declarations: [],
    imports: [CommonModule, BetslipBaseModule, RewardTokensValidatorsModule],
    providers: [RewardTokensStateStorageService, RewardTokensBannerService, RewardTokensMapper, RewardTokensBootstrapService],
})
export class RewardTokensModule {}
